import FooterBar from './footer-bar.vue'

export default FooterBar
